import React, { useState } from "react";
import { Modal, Button } from "react-bootstrap";
import TextField from "@material-ui/core/TextField";
import { v4 as uuid } from "uuid";
import axios from "axios";
import { Formik } from "formik";
import * as Yup from "yup";
import InputMask from "react-input-mask";


export default function Edit(props) {
  const { onHide, show, user, onUsers, skip, take, sortFiled, orderBy } = props;
  const { id, firstName, lastName, email, phone } = user;
  const [isError, setIsError] = useState("");


  // const [phoneNumber, setPhoneNumber] = React.useState("");
  // function handleChangePhoneNumber(e) {
  //   setPhoneNumber(e.target.value);
  // }

  const onPutUser = (values, resetForm, setSubmitting) => {
    const user = {
      id: id,
      firstName: values.firstName,
      lastName: values.lastName,
      email: values.email,
      phone: values.phone,
    };
    axios
      .put(`${process.env.REACT_APP_API_URL}user`, user, {
        headers: {
          "x-requestid": uuid(),
        },
      })
      .then(() => {
        onHide(false);
        resetForm();
        setSubmitting(false);
        onUsers(skip, take, sortFiled, orderBy);
      })
      .catch(
        ({
          response: {
            data: { message },
          },
        }) => {
          setIsError(message);
        }
      );
  };

  const EditSchema = Yup.object().shape({
    firstName: Yup.string().required("Firstname is required"),
    lastName: Yup.string().required("Lastname is required"),
    email: Yup.string()
      .email("Wrong email format. E.g. jhon.doe@example.com")
      .min(3, "Minimum 3 symbols")
      .max(50, "Maximum 50 symbols")
      .required("Email is required"),
    phone: Yup.string().required("Phone is required"),
  });

  const getInputClasses = (touched, errors, filedName) => {
    if (touched[filedName] && errors[filedName]) {
      return true;
    }
    if (touched[filedName] && errors[filedName]) {
      return false;
    }

    return false;
  };

  return (
    <Modal
      size="sm"
      onHide={onHide}
      show={show}
      aria-labelledby="edit"
      className="modal-right pr-0"
    >
      {user && Object.keys(user).length !== 0 && user.constructor === Object && (
        <Formik
          initialValues={{
            firstName: firstName,
            lastName: lastName,
            email: email,
            phone: phone,
          }}
          validationSchema={EditSchema}
          onSubmit={(values, { resetForm, setSubmitting }) => {
            onPutUser(values, resetForm, setSubmitting);
          }}
        >
          {({
            values,
            errors,
            touched,
            handleSubmit,
            handleChange,
            handleBlur,
            resetForm,
          }) => (
            <form onSubmit={handleSubmit}>
              <Modal.Header closeButton>
                <Modal.Title id="edit">Edit</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <div className="col-12 pl-4 pr-4">
                  <div className="row">
                    <div className="col-12 col-md-12 col-lg-12">
                      <div className="w-100 pt-2 pb-3 d-flex flex-wrap">
                        <TextField
                          id="firstName"
                          name="firstName"
                          label="First name"
                          placeholder="First name"
                          className="w-100"
                          value={values.firstName}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          error={getInputClasses(touched, errors, "firstName")}
                        />
                      </div>
                      {touched.firstName && errors.firstName ? (
                        <div className="fv-plugins-message-container">
                          <div className="fv-help-block">
                            {errors.firstName}
                          </div>
                        </div>
                      ) : null}
                    </div>
                    <div className="col-12 col-md-12 col-lg-12">
                      <div className="w-100 pt-2 pb-3 d-flex flex-wrap">
                        <TextField
                          id="lastName"
                          name="lastName"
                          label="Last name"
                          placeholder="Last name"
                          className="w-100"
                          value={values.lastName}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          error={getInputClasses(touched, errors, "lastName")}
                        />
                      </div>
                      {touched.lastName && errors.lastName ? (
                        <div className="fv-plugins-message-container">
                          <div className="fv-help-block">{errors.lastName}</div>
                        </div>
                      ) : null}
                    </div>
                    <div className="col-12 col-md-12 col-lg-12">
                      <div className="w-100 pt-2 pb-3 d-flex flex-wrap">
                        <TextField
                          id="email"
                          name="email"
                          label="Email"
                          placeholder="Email"
                          className="w-100"
                          value={values.email}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          error={getInputClasses(touched, errors, "email")}
                        />
                      </div>
                      {touched.email && errors.email ? (
                        <div className="fv-plugins-message-container">
                          <div className="fv-help-block">{errors.email}</div>
                        </div>
                      ) : null}
                    </div>
                    <div className="col-12 col-md-12 col-lg-12">
                      <div className="w-100 pt-2 pb-3 d-flex flex-wrap">
                        {/* <TextField
                          id="phone"
                          name="phone"
                          label="Phone"
                          placeholder="Phone"
                          className="w-100"
                          value={values.phone}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          error={getInputClasses(touched, errors, "phone")}
                        /> */}
                        <InputMask
                          mask="\9\94999999999"
                          value={values.phone}
                          // onChange={(e) => handleChangePhoneNumber(e)}
                          onChange={handleChange}
                          disabled={false}
                          maskChar=""
                          id="phone"
                          type="number"
                        >
                          {() =>
                            <TextField
                              label="Phone number"
                              placeholder="Phone number"
                              className="w-100"
                              name="phone"
                            // onKeyDown={handleEnter}

                            // error={getInputClasses("phone")}
                            // {...formik.getFieldProps("phone")}
                            />}
                        </InputMask>
                        {touched.phone && errors.phone ? (
                          <div className="fv-plugins-message-container">
                            <div className="fv-help-block">{errors.phone}</div>
                          </div>
                        ) : null}
                        {isError && (
                          <div className="fv-plugins-message-container">
                            <div className="fv-help-block MuiFormLabel-root Mui-error">
                              {isError}
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </Modal.Body>
              <Modal.Footer>
                <Button
                  variant="light"
                  onClick={() => {
                    onHide(false);
                    resetForm();
                  }}
                >
                  Close
                </Button>
                <Button type="submit">Save</Button>
              </Modal.Footer>
            </form>
          )}
        </Formik>
      )}
    </Modal>
  );
}
